import { useCallback, useMemo } from "react";
import { useQuery } from "react-query";
import axios from "axios";
import { ActiveCampaignContactCustomFields } from "@hilos/types/private-schema";
import { API_ROUTES } from "src/router/router";

export function useActiveCampaignContactFields() {
  const fetchActiveCampaignContactFields = useCallback(async () => {
    const { data } = await axios.get<ActiveCampaignContactCustomFields[]>(
      API_ROUTES.ACTIVECAMPAIGN_CUSTOM_FIELDS
    );
    return data;
  }, []);

  const { data } = useQuery(
    "hubspot_contact_fields",
    fetchActiveCampaignContactFields,
    {
      refetchOnWindowFocus: false,
    }
  );

  const fieldsOptions = useMemo(() => {
    return Object.fromEntries(
      data?.map((property) => [property.name, property.options ?? []]) ?? []
    );
  }, [data]);

  return { data: data ?? [], fieldsOptions };
}
